import type { CSSProperties } from 'react';

// Per-item stagger for the `anim-enter` CSS class. A list's delay depends on
// the item index, so it can't be a static Tailwind class — it rides in as an
// inline custom property instead. Replaces framer's `transition={{ delay }}`
// and `staggerChildren`.
//
//   <li style={animDelay(index * 30)} className="anim-enter">
export const animDelay = (ms: number) =>
  ({ '--enter-delay': `${ms}ms` }) as CSSProperties;

export default animDelay;
